import moment from 'moment'

/**
 * 时间格式化
 * @param {Object} val
 */
export function dateFormat(val) {
    if(!val) {
      return '未知'
    }
    const date = new Date(val)
    return moment(date).format('YYYY-MM-DD')
}

/**
 * 时间格式化
 * @param {String} value
 */
export function timeFormat(value) {
    return value === null ? '' : moment(value).format('YYYY-MM-DD HH:mm:ss')
}

/**
 * 将秒转化为多少天
 * @param {秒数} s
 */
export function secondsToTime(s) {
    return formatSeconds(s)
}

/**
 * 小时前
 * @param {Object} val
 */
export function hoursAgo(val) {
    const date = moment(val)
    return moment().diff(date, 'hour')
}

/**
 * 绩效分配类别
 */
export function performanceType(val) {
    const res = {
        0: '绩效分配',
        1: '奖励分配'
    }
    if (res[val]) {
        return res[val]
    }
    return val
}

/**
 * 节点状态
 * @param {Object} val
 */
export function nodeStatus(val) {
    const res = {
        ENABLED: '正常运行',
        NEW_START_REQUIRED: '待激活',
        PRE_ENABLED: '运行准备中',
        OUTPOINT_SPENT: '已失效'
    }
    if (res[val]) {
        return res[val]
    }
    return val
}

/**
 * 节点状态
 * @param {Object} val
 */
export function payWay(val) {
    const res = {
        1: '银行卡',
        2: '微信',
        3: '支付宝',
        4: '转红包'
    }
    if (res[val]) {
        return res[val]
    }
    return val
}

export function cashCheck(val) {
  const res = {
    '1': '审核通过',
    '-1': '已驳回',
    '-2': '已取消',
    '0': '待审核',
  }
  if (res[val]) {
      return res[val]
  }
  return val
}

/**
 * 交易类型
 * @param {Object} val
 */
export function txType(val) {
    const res = {
        sent: '已发送',
        received: '已接收',
        moved: '内部转移'
    }
    if (res[val]) {
        return res[val]
    }
    return val
}

/**
 * 格式化秒
 * @param int  value 总秒数
 * @return string result 格式化后的字符串
 */
export function formatSeconds(value) {
    var theTime = parseInt(value) // 需要转换的时间秒
    var theTime1 = 0 // 分
    var theTime2 = 0 // 小时
    var theTime3 = 0 // 天
    if (theTime > 60) {
        theTime1 = parseInt(theTime / 60)
        theTime = parseInt(theTime % 60)
        if (theTime1 > 60) {
            theTime2 = parseInt(theTime1 / 60)
            theTime1 = parseInt(theTime1 % 60)
            if (theTime2 > 24) {
                // 大于24小时
                theTime3 = parseInt(theTime2 / 24)
                theTime2 = parseInt(theTime2 % 24)
            }
        }
    }
    var result = ''
    if (theTime > 0) {
        result = '' + parseInt(theTime) + '秒'
    }
    if (theTime1 > 0) {
        result = '' + parseInt(theTime1) + '分' + result
    }
    if (theTime2 > 0) {
        result = '' + parseInt(theTime2) + '小时' + result
    }
    if (theTime3 > 0) {
        result = '' + parseInt(theTime3) + '天' + result
    }
    return result
}



// WEBPACK FOOTER //
// ./src/filters/index.js